import firebase from 'firebase/app'
import 'firebase/auth'
import store from '../store'
import { SET_USER } from '../store/actions'
 

export const registerFirebase = () => {
	var firebaseConfig = {
		apiKey: 'AIzaSyDSrZAyLE0vjwyHiYIy90cJFod8qjBVqZ4',
		authDomain: 'realeeconomy121.firebaseapp.com',
		databaseURL: 'https://realeeconomy121.firebaseio.com',
		projectId: 'realeeconomy121',
		storageBucket: 'realeeconomy121.appspot.com',
		messagingSenderId: '571591158787',
		appId: '1:571591158787:web:c30c29d33b5eba13da3236',
		measurementId: "G-VLW3V6WFVC"
	}

	// Initialize Firebase
	firebase.initializeApp (firebaseConfig)

	// Set auth state listener
	firebase.auth ().onAuthStateChanged (user => {
		store.commit (SET_USER, user)
	})
}